import infrastructureApi from "./InfrastructureApi";

export async function userLogin(
    email,
    password,
    remember,
    language,
    client_app = "agrinexus"
) {
    try {
        const { data } = await infrastructureApi.post(
            "/login",
            {
                email,
                password,
                remember,
                language,
                client_app,
            }
        );

        return data;
    } catch (err) {
        console.error(err);

        return {
            success: false,
            message: "network_error",
        };
    }
}

